<template>
    <v-layout row fill-height align-start justify-center>
        <v-flex md12 lg8>
            <v-card tile flat>
                <v-container fluid grid-list-xs>
                    <v-layout row>
                        <v-flex grow>
                            <h3>Diagnostic : {{ getText(resultFollowUp.follow_up.treatment.medical_case.diagnostic.type) }}</h3>

                            <h3>Traitement : {{ getText(resultFollowUp.follow_up.treatment.type) }}</h3>
                            <h4 class="mt-2">Suivi : {{
                                    resultFollowUp.follow_up.follow_up_definition.name &&
                                    (resultFollowUp.follow_up.follow_up_definition.name === 'Pre-op' || resultFollowUp.follow_up.follow_up_definition.name === 'preop') ? 'Pré-op' : resultFollowUp.follow_up.follow_up_definition.name
                                }}</h4>
                            <p>Terminé le : {{ resultFollowUp.follow_up.updated_at | shortDate }}</p>

                        </v-flex>
                        <v-flex shrink>
                            <v-btn @click="exportFollowUP" color="primary">Export</v-btn>
                        </v-flex>

                    </v-layout>
                    <v-expansion-panel light>
                        <v-expansion-panel-content row v-for="followUp in resultFollowUp.follow_up.follow_up_scores" :key="followUp.id">
                            <template v-slot:header>
                                <v-flex xs6>
                                    <h2 v-html="followUp.score.name"></h2>
                                </v-flex>
                                <v-flex xs6>
                                    <div>Résultat : <b>{{formatFollowUpScore(followUp, followUp.score.rule)}}</b></div>
                                </v-flex>
                            </template>
                            <v-card>
                                <v-card-text>
                                    <div v-if="hasInstructions(followUp.score.name)">
                                        <h4>{{ instructions[followUp.score.name].title }}</h4>
                                        <div v-html="instructions[followUp.score.name].description"></div>
                                    </div>

                                    <div v-for="group in followUp.groups" :key="group.score_group.id">
                                    <div>
                                        <h3>{{ group.score_group.name}}</h3>
                                        <p v-if="followUp.groups.length > 1">Résultat : {{formatGroupScore(followUp, group, group.score_group.rule)}}</p>
                                    </div>
                                    <v-divider v-if="followUp.groups.length > 1" class="mb-4"></v-divider>
                                    <div class="mb-2">
                                        <h4>{{ group.score_group.instructions }}</h4>
                                    </div>
                                    <div v-for="details in getQuestionForGroup(followUp.details, group.score_group.id)"
                                         :key="details.id">
                                        <h5 v-html="details.score_question.text"></h5>
                                        <p>{{details.score_question_answer.text }}{{ details.score_question_answer.remarks ? (' - ' + details.score_question_answer.remarks) : '' }}</p>
                                    </div>
                                </div>
                                </v-card-text>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-container>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import {mapActions, mapState, mapMutations} from 'vuex'
    import {getTranslationString} from "../../../helper";

    export default {
        name: "FollowUpView",

        data() {
          return {
              instructions: {
                  "Oxford Knee Score": {
                      title: `Grading for the Oxford Knee Score`,
                      description: `<br>
                            <table>
                                <tbody>
                                <tr>
                                    <td style="padding: 20px" width="25%"><strong>Score 0 to 19</strong></td>
                                    <td>
                                        <div>May indicate severe knee arthritis. It is highly likely that you may well require some form of surgical intervention, contact your family physician for a consult with an Orthopaedic Surgeon.</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 20px" width="25%"><strong>Score 20 to 29</strong></td>
                                    <td>
                                        <div>May indicate moderate to severe knee arthritis. See your family physician for an assessment and x-ray. Consider a consult with an Orthopaedic Surgeon.</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 20px" width="25%"><strong>Score 30 to 39</strong></td>
                                    <td>
                                        <div>May indicate mild to moderate knee arthritis. Consider seeing your family physician for an assessment and possible x-ray. You may benefit from non-surgical treatment, such as exercise, weight loss, and /or anti-inflammatory medication&nbsp;</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 20px" width="25%"><strong>Score 40 to 48</strong></td>
                                    <td>
                                        <p align="justify">May indicate satisfactory joint function. May not require any formal treatment.</p>
                                    </td>
                                </tr>
                                </tbody>
                            </table><br>`
                      },
                  "FJS-12": {
                      title: `Legende pour le score FJS-12`,
                      description: `<br>
                            <table>
                                <tbody>
                                <tr>
                                    <td style="padding: 20px" width="25%"><strong>Score 0 à 19</strong></td>
                                    <td>
                                        <div>Indique une conscience très élevée de l'articulation, souvent associée à une douleur ou une gêne importante.</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 20px" width="25%"><strong>Score 20 à 39</strong></td>
                                    <td>
                                        <div>Indique une conscience modérée à élevée de l'articulation.</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 20px" width="25%"><strong>Score 40 à 59</strong></td>
                                    <td>
                                        <div>Indique une conscience modérée de l'articulation.</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 20px" width="25%"><strong>Score 60 à 79</strong></td>
                                    <td>
                                        <p align="justify">Indique une faible conscience de l'articulation, ce qui est généralement un bon résultat post-opératoire.</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 20px" width="25%"><strong>Score 80 à 100</strong></td>
                                    <td>
                                        <p align="justify">Indique une très faible conscience de l'articulation, ce qui est l'objectif idéal après une chirurgie de remplacement articulaire, signifiant que le patient peut presque totalement oublier l'articulation dans ses activités quotidiennes.</p>
                                    </td>
                                </tr>
                                </tbody>
                            </table><br>
                          `
                  },
                  "WOMAC": {
                        title: `Interprétation du Score WOMAC`,
                        description: `<br>
                                <table>
                                    <tbody>
                                    <tr>
                                        <td style="padding: 20px" width="25%"><strong>Score 0 à 19</strong></td>
                                        <td>
                                            <div>Symptômes légers d'arthrose avec peu d'impact sur les activités quotidiennes.</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 20px" width="25%"><strong>Score 20 à 39</strong></td>
                                        <td>
                                            <div>Symptômes modérés d'arthrose avec un impact notable sur les activités quotidiennes.</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 20px" width="25%"><strong>Score 40 à 59</strong></td>
                                        <td>
                                            <div>Symptômes modérés à sévères d'arthrose avec un impact significatif sur les activités quotidiennes.</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 20px" width="25%"><strong>Score 60 à 96</strong></td>
                                        <td>
                                            <div>Symptômes sévères d'arthrose avec un impact important sur les activités quotidiennes et la qualité de vie.</div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table><br>`
                  }
              }
          }
        },
        created() {
            this.setSelectedPatientId(this.$route.params.patient_id)
            this.setSelectedMedicalCaseId(this.$route.params.medical_case_id)
            this.setSelectedTreatmentId(this.$route.params.treatment_id)
            this.setSelectedFollowUpId(this.$route.params.follow_up_id)
            this.viewResult().then(response => {

            }).catch(reason => {
                //Stay here..
            })
        },
        mounted() {
            console.log(this.resultFollowUp);
        },
        computed: {
            ...mapState('follow_ups', {
                resultFollowUp: state => state.resultFollowUp,
            })

        },
        methods: {
            ...mapMutations('medical_cases', [
                'setSelectedMedicalCaseId'
            ]),
            ...mapMutations('treatments', [
                'setSelectedTreatmentId'
            ]),
            ...mapMutations('patients', [
                'setSelectedPatientId'
            ]),
            ...mapMutations('follow_ups', [
                'setSelectedFollowUpId'
            ]),
            ...mapActions('follow_ups', [
                'viewResult', 'exportResult'
            ]),

            formatFollowUpScore(followup, rule) {
                if (rule === 'list') {
                    return this.getAllAnswersList(followup)
                } else {
                    return this.formatScore(followup.value, rule)
                }
            },
            formatGroupScore(followup, group, rule) {
                if (rule === 'list') {
                    return this.getGroupAnswersList(followup, group)
                } else {
                    return this.formatScore(group.value, rule)
                }
            },

            formatScore(score, rule) {
                if (rule === 'sum') {
                    return score.toFixed(2)
                } else {
                    return score.toFixed(2) + " % "
                }
            },
            hasInstructions(score) {
                return this.instructions.hasOwnProperty(score)
            },
            getQuestionForGroup(questionsDetails, groupId) {
                let results = [];
                for (let i = 0; i < questionsDetails.length; i++) {
                    let detail = questionsDetails[i];
                    if (detail.score_question.score_group_id === groupId) {
                        results.push(detail);
                    }
                }
                return results;
            },
            getText(key) {
                return getTranslationString(key)
            },
            exportFollowUP() {
                this.exportResult().then(response => {
                    let fileName = response.headers["content-disposition"].split("filename=")[1];
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
                        window.navigator.msSaveOrOpenBlob(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                            fileName);
                    } else {
                        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', response.headers["content-disposition"].split("filename=")[1]);
                        document.body.appendChild(link);
                        link.click();
                    }
                }).catch(reason => {
                    //Stay here..
                })
            },
            getAllAnswersList(followUp) {
                return followUp.groups.map(
                    (group) => this.getGroupAnswersList(followUp, group)
                ).join(", ")
            },

            getGroupAnswersList(followUp, group) {
                return this.getQuestionForGroup(followUp.details, group.score_group.id).map(
                    (detail) => detail.score_question_answer.text
                ).join(", ")
            }
        }
    }
</script>

<style scoped>
    .height-max {
        height: 100%;
        overflow: hidden;
    }


</style>
